import { SELECT_PROJECT, REFRESH_PROJECT } from "../actionTypes";

const initialState = {
  selectedProjectId: null,
  projectRefreshTimestamp: null,
};

const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_PROJECT:
      return {
        ...state,
        selectedProjectId: action.payload,
      };
    case REFRESH_PROJECT:
      return {
        ...state,
        projectRefreshTimestamp: action.payload,
      };
    default:
      return state;
  }
};

export default projectReducer;

